<app-rc-dialog-wrapper (closePopin)="closePopin()">
  <div class="signal-product">
    @if (productReco?.product) {
      <div class="signal-product__product">
        <div class="signal-product__product-container">
          <img class="product__picture" [src]="productReco?.product?.image" alt="{{ productReco?.product?.name }}" />
          @if (productReco?.product?.productType === ProductType.Wet) {
            <p class="product__category" i18n="@@product-type_wet">Wet</p>
          }
          @if (productReco?.product?.productType === ProductType.Dry) {
            <p class="product__category" i18n="@@product-type_dry">Dry</p>
          }
          <h1 class="rc-title-beta product__title">
            {{ productReco?.product?.name }}
          </h1>
        </div>
      </div>
    }

    <div class="signal-product__mail">
      <h1 class="signal-product__title rc-title-gamma" i18n="@@alert_signal-product-title">Something went wrong with this result.</h1>
      @if (productReco?.product) {
        <p class="signal-product__sub-title" i18n="@@alert_signal-product-description">
          It seems that this product result is not what you were waiting for.
        </p>
      }

      <textarea
        (keyup)="changeMessage($event)"
        class="signal-product__textarea rc-input-textarea"
        placeholder="Please let us know what went wrong..."
        i18n-placeholder="@@alert_signal-placeholder"
      ></textarea>

      <div class="signal-product__button-container dialog_container__footer">
        <rc-link data-qa="vs-signal-product-popin-button-cancel" variant="secondary" size="large" (click)="closePopin()">
          {{ 'action_cancel' | translateKey }}
        </rc-link>
        <span class="rc-button__separator" i18n="@@action_separator">or</span>
        <rc-button
          id="action_send_to_support"
          data-qa="vs-signal-product-popin-button-send"
          [disabled]="!message.length"
          (click)="signalRecommendationEmail($event)"
        >
          {{ 'action_send_to_support' | translateKey }}
        </rc-button>
      </div>
    </div>
  </div>
</app-rc-dialog-wrapper>
